import { shallowRef, type ShallowRef } from "vue";

export type LimitsDialogSaveFn = () => Promise<void>;

/** Set from LimitsDialogTab while mounted; cleared on unmount. Category edit submit calls this before category API. */
export const limitsDialogSaveRef: ShallowRef<LimitsDialogSaveFn | null> = shallowRef(null);
